import { render, staticRenderFns } from "./FREUI.vue?vue&type=template&id=4b00b299&scoped=true&"
import script from "./FREUI.vue?vue&type=script&lang=js&"
export * from "./FREUI.vue?vue&type=script&lang=js&"
import style0 from "./FREUI.vue?vue&type=style&index=0&id=4b00b299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00b299",
  null
  
)

export default component.exports